import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-ink text-off-white pt-20 pb-24 md:pb-10" data-id="element-93">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-95">
          {/* Brand & Contact */}
          <div className="flex flex-col gap-6" data-id="element-96">
            <Link to="/" className="flex items-center group" data-id="element-97">
              <img src="https://cdn.magicpatterns.com/uploads/6QQqEPrZA2yuM42sncUeU3/StormLogo.png" alt="Storm Taekwondo" className="h-20 w-auto object-contain transition-transform group-hover:scale-105" data-id="element-98" />
            </Link>
            <p className="text-gray-warm font-medium" data-id="element-99">
              Building confidence, focus, and discipline in Farmington Hills
              through Olympic-style Taekwondo.
            </p>
            <div className="flex flex-col gap-3 mt-2" data-id="element-100">
              <a href="tel:517-220-0621" className="flex items-center gap-3 text-off-white hover:text-storm-red transition-colors" data-id="element-101">
                <Phone className="w-5 h-5 text-storm-red" data-id="element-102" />
                <span className="font-bold" data-id="element-103">517-220-0621</span>
              </a>
              <div className="flex items-start gap-3 text-off-white" data-id="element-104">
                <MapPin className="w-5 h-5 text-storm-red shrink-0 mt-1" data-id="element-105" />
                <span data-id="element-106">
                  24786 Crestview
                  <br data-id="element-107" />
                  Farmington Hills, MI 48335
                </span>
              </div>
            </div>
          </div>

          {/* Programs */}
          <div data-id="element-108">
            <h4 className="text-xl text-white mb-6" data-id="element-109">Programs</h4>
            <ul className="flex flex-col gap-3" data-id="element-110">
              <li data-id="element-111">
                <Link to="/kids-taekwondo-classes" className="text-gray-warm hover:text-white transition-colors" data-id="element-112">
                  Kids Taekwondo (Ages 6+)
                </Link>
              </li>
              <li data-id="element-113">
                <Link to="/mini-troopers" className="text-gray-warm hover:text-white transition-colors" data-id="element-114">
                  Mini Troopers (Ages 3-5)
                </Link>
              </li>
              <li data-id="element-115">
                <Link to="/adult-taekwondo-classes" className="text-gray-warm hover:text-white transition-colors" data-id="element-116">
                  Adult Taekwondo
                </Link>
              </li>
              <li data-id="element-117">
                <Link to="/family-martial-arts-classes" className="text-gray-warm hover:text-white transition-colors" data-id="element-118">
                  Family Classes
                </Link>
              </li>
              <li data-id="element-119">
                <Link to="/self-defense-classes" className="text-gray-warm hover:text-white transition-colors" data-id="element-120">
                  Self-Defense
                </Link>
              </li>
              <li data-id="element-121">
                <Link to="/competition-team" className="text-gray-warm hover:text-white transition-colors" data-id="element-122">
                  Competition Team
                </Link>
              </li>
              <li data-id="element-123">
                <Link to="/summer-camp" className="text-storm-red font-bold hover:text-white transition-colors flex items-center gap-2" data-id="element-124">
                  <span className="w-1.5 h-1.5 rounded-full bg-storm-red animate-pulse" data-id="element-125" />
                  Summer Camp
                </Link>
              </li>
            </ul>
          </div>

          {/* Locations */}
          <div data-id="element-126">
            <h4 className="text-xl text-white mb-6" data-id="element-127">Service Areas</h4>
            <ul className="flex flex-col gap-3" data-id="element-128">
              <li data-id="element-129">
                <Link to="/farmington-hills-martial-arts" className="text-gray-warm hover:text-white transition-colors" data-id="element-130">
                  Farmington Hills
                </Link>
              </li>
              <li data-id="element-131">
                <Link to="/novi-martial-arts" className="text-gray-warm hover:text-white transition-colors" data-id="element-132">
                  Novi
                </Link>
              </li>
              <li data-id="element-133">
                <Link to="/commerce-martial-arts" className="text-gray-warm hover:text-white transition-colors" data-id="element-134">
                  Commerce
                </Link>
              </li>
              <li data-id="element-135">
                <Link to="/livonia-martial-arts" className="text-gray-warm hover:text-white transition-colors" data-id="element-136">
                  Livonia
                </Link>
              </li>
              <li data-id="element-137">
                <Link to="/waterford-martial-arts" className="text-gray-warm hover:text-white transition-colors" data-id="element-138">
                  Waterford
                </Link>
              </li>
              <li data-id="element-139">
                <Link to="/northville-martial-arts" className="text-gray-warm hover:text-white transition-colors" data-id="element-140">
                  Northville
                </Link>
              </li>
            </ul>
          </div>

          {/* CTA & Social */}
          <div className="flex flex-col gap-4" data-id="element-141">
            <h4 className="text-xl text-white mb-2" data-id="element-142">Ready to Start?</h4>
            <Link to="/free-trial" className="btn-primary text-center w-full" data-id="element-143">
              Claim Free Week
            </Link>

            <div className="pt-4 mt-2 border-t border-charcoal" data-id="element-144">
              <p className="text-xs uppercase tracking-wide text-gray-warm font-bold mb-3" data-id="element-145">
                Looking for a Summer Activity?
              </p>
              <Link to="/summer-camp" className="block bg-charcoal hover:bg-storm-red transition-colors text-white text-center font-display text-lg tracking-wide uppercase py-3 px-4 rounded-xl border border-storm-red/40" data-id="element-146">
                View Storm Summer Camp
              </Link>
            </div>

            <div className="flex items-center gap-4 mt-2" data-id="element-147">
              <a href="#" className="w-10 h-10 rounded-full bg-charcoal flex items-center justify-center hover:bg-storm-red transition-colors text-white" data-id="element-148">
                <Facebook className="w-5 h-5" data-id="element-149" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-charcoal flex items-center justify-center hover:bg-storm-red transition-colors text-white" data-id="element-150">
                <Instagram className="w-5 h-5" data-id="element-151" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-charcoal flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-152">
          <p className="text-gray-warm text-sm" data-id="element-153">
            &copy; {new Date().getFullYear()} Storm Taekwondo. All rights
            reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-warm" data-id="element-154">
            <Link to="/privacy" className="hover:text-white transition-colors" data-id="element-155">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-white transition-colors" data-id="element-156">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}